import React from 'react'

import './CalendarIcon.scss'
import calendarIcon from './calendar.svg'

const CalendarIcon = ({ onClick }) => {
    return <img src={calendarIcon} onClick={onClick} />
}

export default CalendarIcon
